var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTryIndexingCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 162,
    viewBox: "0 0 308 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    width: 312,
    height: 41,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 46,
    width: 268,
    height: 118,
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.149 62C88.4737 62 45.9349 66.8 27 69.2V94H310.244L315 70.2C297.824 70.2 272.746 63.8 253.808 63.8C234.87 63.8 222.099 70.2 189.949 70.2C157.799 70.2 130.494 62 107.149 62Z",
    fill: "#29B2DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4057 26.0686C19.577 23.409 0.370627 31.6095 -7.12899 36.0422L-13 52H326L321.108 46.6807C315.727 41.3615 303.204 29.7921 296.16 26.0686C287.355 21.4143 284.42 26.0686 280.996 26.0686C277.571 26.0686 268.277 30.7229 244.307 36.0422C225.132 40.2976 213.815 37.8153 210.554 36.0422C195.227 32.7177 157.919 26.0686 131.307 26.0686C98.0433 26.0686 103.913 36.0422 92.6623 36.0422C81.4113 36.0422 57.4416 29.3931 36.4057 26.0686Z",
    fill: "#01496E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.149 78C182.474 78 139.935 82.65 121 84.975V109H404.244L409 85.9437C391.824 85.9437 366.746 79.7437 347.808 79.7437C328.87 79.7437 316.099 85.9437 283.949 85.9437C251.799 85.9437 224.494 78 201.149 78Z",
    fill: "#53CFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.149 88C123.474 88 80.9349 94.6 62 97.9V132H345.244L350 99.275C332.824 99.275 307.746 90.475 288.808 90.475C269.87 90.475 257.099 99.275 224.949 99.275C192.799 99.275 165.494 88 142.149 88Z",
    fill: "#29B1DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.746 78.9556C275.686 78.6472 274.576 79.2571 274.268 80.3177L269.385 97.1116C265.405 97.5132 261.877 100.272 260.692 104.349L255.212 123.196C253.671 128.499 256.72 134.048 262.023 135.59L262.229 135.65C267.532 137.192 273.081 134.142 274.623 128.839L280.102 109.992C281.287 105.918 279.79 101.699 276.649 99.2258L281.532 82.4298C281.841 81.3691 281.231 80.2593 280.17 79.951L276.746 78.9556Z",
    fill: "#01496E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.703 110.278C278.411 109.149 278.185 107.917 277.984 107.442L275.02 110.168L275.167 111.667C275.718 111.674 276.996 111.407 277.703 110.278Z",
    fill: "#BBA376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.273 128.367C265.038 121.026 270.193 109.286 271.924 104.334C276.027 102.737 277.87 106.075 278.279 107.944C272.727 112.912 266.865 126.036 264.627 131.977C260.495 133.158 258.669 130.063 258.273 128.367Z",
    fill: "#FFD687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.226 108.036C277.683 108.993 275.82 108.96 274.065 107.963C272.31 106.967 271.328 105.383 271.872 104.426C272.415 103.47 274.278 103.502 276.033 104.499C277.788 105.496 278.77 107.079 278.226 108.036Z",
    fill: "#BBA376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.038 110.874C277.312 111.904 278.332 109.415 278.307 108.042C279.239 110.036 270.667 125.449 266.265 132.906C265.42 133.691 262.539 133.702 261.205 133.61C263.768 133.668 270.161 118.477 273.038 110.874Z",
    fill: "#FFF5E1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.046 119C198.152 119 171.059 125.75 159 129.125V164H309.622L320 131.937C309.061 131.937 315.512 121.531 303.451 121.531C291.39 121.531 283.256 130.531 262.78 130.531C242.304 130.531 224.914 119 210.046 119Z",
    fill: "#53CFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.045 135C218.122 135 184.13 141.75 169 145.125V180H357.979L371 147.937C357.275 147.937 365.369 137.531 350.237 137.531C335.104 137.531 324.898 146.531 299.208 146.531C273.518 146.531 251.699 135 233.045 135Z",
    fill: "#29B1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5101 55.6374C85.0265 51.6286 25.8852 50.2088 -2 50V164H214C188.405 147.297 136.715 109.255 134.717 90.7143C132.719 72.1736 109.747 59.6044 98.5101 55.6374Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.878 151.145C152.322 148.794 138.4 150.573 127.73 143.71C115.434 135.831 110.294 117.975 95.9166 115.052C81.9291 112.129 69.6332 125.601 55.3855 126.363C44.0654 126.935 34.0464 119.5 26.4997 111.24C18.953 103.043 12.5122 93.448 2.94869 87.5386C-2.45113 84.1708 -9.41234 82.4552 -15.723 83.1541C-17.2193 91.9865 -18 101.01 -18 110.287C-18 131.002 -14.0965 150.763 -6.94014 169H195C187.258 160.041 176.719 153.369 164.878 151.145Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.084 30.162C66.1097 25.9744 60.5656 22.64 55.7772 23.4756C50.9887 24.3112 48.5606 29.7691 49.4145 34.3799C50.201 38.9479 56.7263 44.6089 64.0195 43.8514C68.857 43.2362 70.6591 35.4884 68.084 30.162Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6032 42.7992C63.1377 39.5972 59.2292 37.1132 55.7879 37.7643C52.3466 38.4154 50.6832 42.3724 51.3343 45.8137C51.9854 49.255 57.9892 53.3546 61.3877 52.7709C64.7616 52.0769 66.4181 46.791 64.6032 42.7992Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.14 44.2488C59.0762 50.4524 63.3291 55.5206 67.1627 55.5919C70.929 55.6203 72.8122 50.5731 72.876 44.3695C72.9398 38.1659 69.8577 34.9771 66.0914 34.9486C62.3252 34.9202 59.2038 38.0452 59.14 44.2488Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2628 46.3947C56.2942 47.8338 57.6426 49.7315 58.6837 49.7309C59.7247 49.7303 59.9874 48.5727 60.0234 47.1764C59.9919 45.7373 59.1644 44.3599 58.1233 44.3605C57.1679 44.2263 56.3416 44.9311 56.2628 46.3947Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2558 40.2771C58.2558 40.2771 59.6314 36.3263 62.7231 34.8854C65.8823 33.4873 71.8472 33.7779 73.0752 39.2887C73.0752 39.2887 73.5612 43.2873 68.6928 43.5045C63.8244 43.7216 64.9008 41.2837 62.3116 43.4224C59.7898 45.604 57.7984 43.6761 57.2782 44.197L58.2558 40.2771Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2546 125.467C38.2531 125.386 38.2501 125.224 38.3487 125.142C38.6326 124.248 39.8249 123.747 40.9305 123.977L55.5115 127.447C56.6171 127.676 57.2355 128.641 56.9515 129.535C56.6676 130.429 55.4754 130.93 54.3698 130.7L39.7887 127.23C38.7833 127 38.1678 126.197 38.2546 125.467Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2043 122.451C40.2043 122.451 35.1622 120.487 34.7811 121.544C34.3986 122.521 29.966 137.395 30.7713 137.629C33.5889 138.405 39.4808 126.671 39.4585 125.457C39.4347 124.161 40.9109 122.767 40.2043 122.451Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.654 82.9114C105.654 82.9114 113.023 76.1773 115.462 76.5349C117.972 76.9509 111.682 84.1044 105.812 85.3022L105.654 82.9114Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.476 80.8521C108.136 82.351 108.796 83.8498 109.444 85.2197C86.0956 95.5902 72.6752 91.1209 64.2814 65.9624C62.9477 62.1208 64.2832 61.8012 67.0712 61.0209C67.3514 60.5397 67.2224 60.5517 67.0712 61.0209C69.8591 60.2407 71.0674 60.6481 72.1897 64.3143C79.5024 88.3384 86.4843 86.5166 107.476 80.8521Z",
    fill: "#8FCCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3685 123.125C31.4601 122.942 31.5516 122.759 31.6432 122.576C32.284 121.752 33.3826 121.66 34.2981 122.118L46.0165 129.076C46.8404 129.625 47.2982 130.723 46.8405 131.639C46.3827 132.646 45.101 133.104 44.094 132.463L32.1925 125.322C31.4601 124.956 31.0939 123.949 31.3685 123.125Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5859 128.343C36.7761 127.062 38.0578 125.78 39.3395 124.498C84.8397 149.949 105.621 142.533 55.9099 113.878C51.3324 111.223 49.9592 105.273 52.9804 100.878C53.8043 99.6881 54.6282 98.5896 55.4522 97.3994C111.664 135.118 101.959 164.872 35.5859 128.343Z",
    fill: "#292B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.615 128.011C43.6923 126.703 44.8697 125.393 46.047 124.083C123.023 145.025 91.438 120.622 61.1574 107.298C56.5142 105.248 56.1173 99.9884 59.3611 96.7098C60.64 95.4796 61.9175 94.1684 63.1965 92.9382C115.679 126.729 124.919 150.105 42.615 128.011Z",
    fill: "#292B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5705 121.752C34.5705 121.752 30.2677 119.006 29.7184 120.104C29.1691 121.203 23.0353 137.224 23.7677 137.59C26.2395 138.78 33.2888 126.329 33.4719 124.956C33.655 123.491 35.2114 122.118 34.5705 121.752Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0385 108.66C71.1934 110.216 66.1581 109.942 62.3131 108.843C59.475 108.019 53.6158 103.808 49.4961 104.082L51.3271 88.4274L50.6863 65.4484C50.6863 60.5047 54.7145 56.4766 59.6581 56.4766H63.8694C68.8131 56.4766 72.8413 60.5047 72.8413 65.4484L72.2005 88.519L75.0385 108.66Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1016 47.4133L65.2354 46.7725C65.327 47.5964 65.9678 55.5612 65.6932 58.5824C65.5101 59.4979 63.9537 59.9556 62.3058 59.4979C60.841 59.1317 59.7424 58.2162 59.7424 57.3922C59.7424 55.6528 59.3762 50.3429 59.1016 47.4133Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9523 99.9629C35.9523 99.9629 42.2692 107.653 41.7199 110.125C41.1706 112.597 34.396 105.914 33.4805 99.9629H35.9523Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8674 101.885C36.3111 102.434 34.8462 103.075 33.3814 103.624C24.2265 79.73 29.5364 66.6383 55.0787 59.589C59.0154 58.4904 59.1985 59.8637 59.9309 62.7017C60.4802 62.9763 60.3886 62.8848 59.9309 62.7017C60.5717 65.5397 60.1139 66.7299 56.3604 67.6454C31.9166 73.5046 33.3815 80.6454 37.8674 101.885Z",
    fill: "#8FCCCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 154,
    y1: 0,
    x2: 154,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0181A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 176,
    y1: 46,
    x2: 176,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1289BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#3ED4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470063,
    stopColor: "#7FE4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8EFFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 308,
    height: 162,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTryIndexingCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/try-indexing-card.fe52c30bc462bf6156ebf20e7f6c9c1c.svg";